export const ThailandImages ={
    d1 : require('./thaiport1.jpg').default,
    d2 : require('./thaiport2.jpg').default,
    db1 : require('./temple1.jpg').default,
    db2 : require('./temple2.jpg').default,
    dh1 : require('./hotel1.jpg').default,
    dh2 : require('./hotel2.jpg').default,
    dp1 : require('./pack1.jpg').default,
    dp2 : require('./pack2.jpg').default,
    dp3 : require('./pack3.jpg').default,
    dp4 : require('./pack4.jpg').default,
    do1 : require('./only1.jpg').default,
    do2 : require('./only2.jpg').default,
}